const SET_COLOR_PICKER_OPEN = 'crazyEditor/colorPicker/SET_COLOR_PICKER_OPEN';
const SET_ON_SELECT = 'crazyEditor/colorPicker/SET_ON_SELECT';
const SET_ANCHOR = 'crazyEditor/colorPicker/SET_ANCHOR';

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case SET_COLOR_PICKER_OPEN:
      return {
        ...state,
        open: action.open
      };
    case SET_ON_SELECT:
      return {
        ...state,
        onSelect: action.onSelect
      };
    case SET_ANCHOR:
      return {
        ...state,
        anchor: action.anchor
      };
    default:
      return state;
  }
}

export function setColorPickerOpen(open) {
  return {type: SET_COLOR_PICKER_OPEN, open};
}

export function setOnSelect(onSelect) {
  return {type: SET_ON_SELECT, onSelect};
}

export function setAnchor(anchor) {
  return {type: SET_ANCHOR, anchor};
}
